import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { REDIRECT_CONFIG, DEFAULT_REDIRECT_URL } from 'utils/redirectConfig';

const findRedirectTarget = (pathname: string): string => {
    // Check for prefix match (path starts with configured pattern)
    for (const [pattern, target] of REDIRECT_CONFIG) {
        if (pathname.startsWith(pattern + '/') || pathname === pattern) {
            return target;
        }
    }
    return DEFAULT_REDIRECT_URL;
};

const HomePage: FC = () => {
    const location = useLocation();
    const redirectTarget = findRedirectTarget(location.pathname);
    globalThis.location.href = redirectTarget;
    return null;
};
export default HomePage;
